/* src/app/shared/components/cert-area-assignment/cert-area-assignment.component.scss */
th {
  background-color: #f0f0f0;
  color: black;
  font-weight: 600;
  text-align: left;
  padding: 15px 0;
  width: 100%;
}
/*# sourceMappingURL=cert-area-assignment.component.css.map */
